<template>
  <v-container fluid class="px-5">
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <!-- SNACKBAR -->

    <v-dialog v-model="dialog" persistent max-width="550px">
      <v-card>
        <v-form ref="fmodelosSLA">
          <v-card-title class="px-4 py-6">
            <span class="text-h5 px-4">Ingrese Datos</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row class="px-6">
                <v-col cols="12" md="4" class="px-1 ma-0">
                  <v-text-field
                    v-model.trim="selected.placa"
                    label="Placa"
                    dense
                    readonly
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="px-1 ma-0">
                  <v-text-field
                    v-model.trim="selected.reclamo"
                    label="Reclamo"
                    :rules="requiredRule"
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="px-1 ma-0">
                  <v-text-field
                    v-model.trim="selected.numeroAsistencia"
                    label="Número Asistencia"
                    :rules="requiredRule"
                    dense
                    required
                    @keypress.enter="getDatosAsistencia"
                    hint="PRESIONAR ENTER"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-1 ma-0">
                  <v-text-field
                    v-model.trim="selected.error"
                    label="Error"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-1 pt-0 ma-0">
                  <v-text-field
                    v-model.trim="selected.solicitudAnalista"
                    label="Solicitud Analista"
                    :rules="requiredRule"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-1 pt-0 ma-0">
                  <v-text-field
                    v-model.trim="selected.resolucionEjecutivo"
                    label="Resoluciones Ejecutivo"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-1 ma-0">
                  <v-autocomplete
                    v-model="selected.grupoSLAId"
                    :items="grupoSLA"
                    label="Grupo SLA"
                    item-text="nombre"
                    item-value="id"
                    :rules="requiredRule"
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="px-1 ma-0">
                  <v-autocomplete
                    v-model="selected.cartera"
                    :items="carteras"
                    label="Aseguradora"
                    item-text="nombre"
                    item-value="nombre"
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" class="px-1 ma-0">
                  <v-text-field
                    v-model.trim="selected.fechaSolicitudHelper"
                    label="Fecha Solicitud"
                    type="datetime-local"
                    :rules="requiredRule"
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="px-1 ma-0">
                  <v-text-field
                    v-model.trim="selected.fechaRespuestaHelper"
                    label="Fecha Respuesta"
                    type="datetime-local"
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-7 pb-4 pt-0">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text outlined @click="limpiar">
              Cerrar
            </v-btn>
            <v-btn color="blue darken-1" dark @click="guardar"> Guardar </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-row align="center" justify="center" class="pt-4 pb-1">
      <v-spacer></v-spacer>

      <v-col class="pt-0" cols="12" md="2">
        <v-text-field
          v-model="fechaInicio"
          type="date"
          hide-details
          dense
          label="Inicio"
          clearable
        ></v-text-field>
      </v-col>
      <v-col class="pt-0" cols="12" md="2">
        <v-text-field
          v-model="fechaFin"
          type="date"
          dense
          hide-details
          label="Fin"
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="1" class="text-right pt-0">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="primary"
              dark
              :block="$vuetify.breakpoint.smAndDown"
              @click="listar"
            >
              Listar
            </v-btn>
          </template>
          <span>Listar</span>
        </v-tooltip>
      </v-col>
      <v-col class="pt-0" cols="12" md="1">
        <v-tooltip bottom color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="green"
              :block="$vuetify.breakpoint.smAndDown"
              dark
              @click="downloadReporte"
            >
              <v-icon>fas fa-file-download</v-icon>
            </v-btn>
          </template>
          <span>Descargar</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row>
      <v-col cols="12">
        <v-stepper non-linear v-model="step">
          <v-stepper-header>
            <v-stepper-step editable step="1"> Modelo SLA</v-stepper-step>
            <v-divider></v-divider>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-row>
                <v-col class="pt-0 pl-4" cols="12" md="4">
                  <v-text-field
                    class="text-xs-center"
                    v-model="search"
                    dense
                    append-icon="search"
                    label="Búsqueda"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" class="pt-0 pl-4">
                  <v-btn
                    class="mx-2"
                    dark
                    color="primary"
                    @click="dialog = true"
                  >
                    Agregar
                    <v-icon dark small class="pl-1"> fa-plus </v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-data-table
                :headers="headerGeneral"
                :items="modelosSLA"
                :loading="loader"
                loading-text="Listando Datos..."
                no-data-text="No se encontraron resultados..."
                :search="search"
                class="elevation-2"
              >
                <template v-slot:[`item.opciones`]="{ item }">
                  <v-tooltip left color="primary" dark>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        @click="verDetalles(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                      >
                        far fa-edit
                      </v-icon>
                    </template>
                    <span>Ver Detalles</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.validoDesde`]="{ item }">
                  {{ formatDate(item.validoDesde) }}
                </template>
                <template v-slot:[`item.validoHasta`]="{ item }">
                  {{ formatDate(item.validoHasta) }}
                </template>
              </v-data-table>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
import moment from "moment";

export default {
  name: "ModeloSLA",
  data() {
    return {
      step: 1,
      snack: false,
      carteras: [],
      requiredRule: [(v) => !!v || "Campo obligatorio"],
      fechaInicio: new Date().toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      selected: {
        id: null,
        cartera: "",
        fechaSolicitudHelper: new Date().toISOString().substr(0, 10),
        placa: null,
        reclamo: null,
        numeroAsistencia: null,
        solicitudAnalista: null,
        grupoSLAId: null,
        resolucionEjecutivo: null,
        fechaRespuestaHelper: null,
        error: null,
      },
      resolucionesEjecutivo: [],
      grupoSLA: [],
      dialog: false,
      snackColor: "primary",
      snackTime: 6500,
      snackText: "Notification",
      modelosSLA: [],
      loader: false,
      search: "",
      headerGeneral: [
        {
          text: "Aseguradora",
          value: "cartera",
          align: "center",
          sortable: true,
          width: 200,
        },
        {
          text: "FechaSolicitud",
          value: "fechaSolicitud",
          align: "center",
          sortable: true,
          width: 130,
        },
        {
          text: "HoraSolicitud",
          value: "horaSolicitud",
          align: "center",
          sortable: true,
          width: 130,
        },
        {
          text: "Placa",
          value: "placa",
          align: "center",
          sortable: true,
          width: 150,
        },
        {
          text: "Reclamo",
          value: "reclamo",
          align: "center",
          sortable: true,
          width: 200,
        },
        {
          text: "N° Asistencia",
          value: "numeroAsistencia",
          align: "center",
          sortable: true,
          width: 150,
        },
        {
          text: "Solicitud Analista",
          value: "solicitudAnalista",
          align: "center",
          sortable: true,
          width: 300,
        },
        {
          text: "Grupo SLA",
          value: "grupoSLA",
          align: "center",
          sortable: true,
          width: 300,
        },
        {
          text: "Resolucion Ejecutivo",
          value: "resolucionEjecutivo",
          align: "center",
          sortable: true,
          width: 300,
        },
        {
          text: "FechaRespuesta",
          value: "fechaRespuesta",
          align: "center",
          sortable: true,
          width: 140,
        },
        {
          text: "HoraRespuesta",
          value: "horaRespuesta",
          align: "center",
          sortable: true,
          width: 130,
        },
        {
          text: "Error",
          value: "error",
          align: "center",
          sortable: true,
          width: 300,
        },
        {
          text: "Dias Respuesta",
          value: "diasRespuesta",
          align: "center",
          sortable: true,
          width: 130,
        },
        {
          text: "Horas Respuesta",
          value: "horasRespuesta",
          align: "center",
          sortable: true,
          width: 140,
        },
        {
          text: "Opciones",
          value: "opciones",
          align: "center",
          sortable: false,
          width: 100,
        },
      ],
    };
  },
  created() {
    this.listarComboBox();
    this.listar();
  },
  computed: {},
  methods: {
    listarComboBox() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/ModelosSLA/GrupoSLA", configuracion)
        .then((res) => {
          this.grupoSLA = res.data;
        })
        .catch((err) => {
          console.error(err);
        });

      axios
        .get("api/Carteras/Activas", configuracion)
        .then((res) => (this.carteras = res.data))
        .catch((err) => console.error(err));
    },
    formatDate(fecha) {
      if (fecha == null) return "- - - -";
      if (!fecha || typeof fecha != "string") {
        throw new Error(
          "El parametro 'fecha' debe ser de tipo String y no puede estar vacio",
        );
      }

      return moment(fecha).format("YYYY-MM-DD HH:mm:ss");
    },
    nuevo() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.$refs.fmodelosSLA.validate()) {
        axios
          .post("api/ModelosSLA", this.selected, configuracion)
          .then((res) => {
            this.snackText = "Nuevo Registro Creado!";
            this.snackColor = "primary";
            this.snack = true;

            this.limpiar();
            this.listar();
          })
          .catch((err) => {
            console.error(err);

            this.snackText = "No se Pudo Crear El Registro";
            if (err.response.status == 400 || err.response.status == 404) {
              this.snackText = err.response.data;
            }

            this.snackColor = "error";
            this.snack = true;
          });
      } else {
        this.snackText = "Complete los Campos Necesarios";
        this.snackColor = "error";
        this.snack = true;
      }
    },
    actualizar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.$refs.fmodelosSLA.validate()) {
        axios
          .put(`api/ModelosSLA`, this.selected, configuracion)
          .then((res) => {
            this.snackText = "Registro Actualizado!";
            this.snackColor = "primary";
            this.snack = true;

            this.limpiar();
            this.listar();
          })
          .catch((err) => {
            console.error(err);

            this.snackText = "No se Pudo Actualizar el Registro";
            if (err.response.status == 400 || err.response.status == 404) {
              this.snackText = err.response.data;
            } else {
              this.snackText = "No se Pudo Actualizar el Registro";
            }

            this.snackColor = "error";
            this.snack = true;
          });
      } else {
        this.snackText = "Complete los Campos Necesarios";
        this.snackColor = "error";
        this.snack = true;
      }
    },
    guardar() {
      if (!this.selected?.id) {
        this.nuevo();
      } else {
        this.actualizar();
      }
    },
    limpiar() {
      this.selected = {
        id: null,
        cartera: "",
        fechaSolicitud: null,
        placa: null,
        reclamo: null,
        numeroAsistencia: null,
        solicitudAnalista: null,
        grupoSLAId: null,
        resolucionEjecutivo: null,
        fechaRespuesta: null,
        error: null,
      };
      this.dialog = false;

      if (this.$refs.fmodelosSLA) {
        this.$refs.fmodelosSLA.resetValidation();
      }
    },
    verDetalles(item) {
      this.selected = { ...item };
      this.dialog = true;
    },
    listar() {
      this.loader = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/ModelosSLA?inicio=${this.fechaInicio}&fin=${this.fechaFin}`,
          configuracion,
        )
        .then((res) => {
          this.modelosSLA = res.data;
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    getDatosAsistencia() {
      if (!this.selected.numeroAsistencia) return;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/ModelosSLA/Asistencia/${this.selected.numeroAsistencia}`,
          configuracion,
        )
        .then((res) => {
          this.selected.placa = res.data;
        })
        .catch((err) => console.error(err));
    },
    downloadReporte() {
      const workbook = XLSX.utils.book_new();

      const formattedData = this.modelosSLA.map(
        ({
          id,
          grupoSLAId,
          fechaSolicitudHelper,
          fechaRespuestaHelper,
          ...rest
        }) => {
          return rest;
        },
      );

      const data = XLSX.utils.json_to_sheet(formattedData);
      XLSX.utils.book_append_sheet(workbook, data, "modelosSLA");

      const filename = "modelosSLA.xlsx";
      XLSX.writeFile(workbook, filename);
    },
  },
};
</script>
